import i18n from '../../utils/i18n';

export const RANGE_FILTERS = [
	{
		label: i18n.t('components.filterBar.rangeFilters.efficiency'),
		name: 'efficiency',
		unit: '[%]'
	},
	{
		label: i18n.t('components.filterBar.rangeFilters.icTemperature'),
		name: 'icTemperature',
		unit: '[\u00B0C]'
	},
	{
		label: i18n.t('components.filterBar.rangeFilters.designFootprint'),
		name: 'designFootprint',
		unit: '[mm\u00b2]'
	},
	{
		label: i18n.t('components.filterBar.rangeFilters.switchingFrequency'),
		name: 'switchingFrequency',
		unit: '[kHz]'
	},
	{
		label: i18n.t('components.filterBar.rangeFilters.designPrice'),
		name: 'designPrice',
		unit: '[$]'
	}
];

export const CHECKBOX_FILTERS = [
	{
		label: i18n.t('components.filterBar.checkboxFilters.topology'),
		name: 'topology',
		booleanFilters: false,
		filters: [
			{
				label: i18n.t('topologies:BUCK'),
				name: 'BUCK',
				forced: false
			},
			{
				label: i18n.t('topologies:BOOST'),
				name: 'BOOST',
				forced: false
			},
			{
				label: i18n.t('topologies:FLYBACK'),
				name: 'FLYBACK',
				forced: false
			},
			{
				label: i18n.t('topologies:QR_FLYBACK'),
				name: 'QR_FLYBACK',
				forced: false
			},
			{
				label: i18n.t('topologies:CHARGE_PUMP'),
				name: 'CHARGE_PUMP',
				forced: false
			},
			{
				label: i18n.t('topologies:LDO'),
				name: 'LDO',
				forced: false
			},
			{
				label: i18n.t('topologies:INVERTING_BUCK_BOOST'),
				name: 'INVERTING_BUCK_BOOST',
				forced: false
			}
		]
	},
	{
		label: i18n.t('components.filterBar.checkboxFilters.topologyCategory'),
		name: 'topologyCategory',
		booleanFilters: false,
		filters: [
			/* Buck, Boost, Flyback, IBB */
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.synchIntegratedM'),
				name: 'synchIntegratedMOSFET',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.asynchIntegratedM'),
				name: 'asynchIntegratedMOSFET',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.synchExternalM'),
				name: 'synchExternalMOSFET',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.asynchExternalM'),
				name: 'asynchExternalMOSFET',
				forced: false
			},
			/* Charge pump */
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.chpIntegratedM'),
				name: 'chargePumpIntegratedMOSFET',
				forced: false
			},
			/* LDO */
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.internalResistorDivider'),
				name: 'internalResistorDivider',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.externalResistorDivider'),
				name: 'externalResistorDivider',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.topologyCategory.externalResistorDividerFloat'),
				name: 'externalResistorDividerFloat',
				forced: false
			}
		]
	},
	{
		label: i18n.t('components.filterBar.checkboxFilters.icPackage'),
		name: 'icPackage',
		booleanFilters: false,
		filters: []
	},
	{
		label: i18n.t('components.filterBar.checkboxFilters.icFeatures'),
		name: 'icFeatures',
		booleanFilters: true,
		filters: [
			{
				label: i18n.t('components.filterBar.constants.icFeatures.enable'),
				name: 'enable',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.adjustSoftStart'),
				name: 'adjustableSoftStart',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.adjustSwitchingFrequency'),
				name: 'adjustableSwitchingFrequency',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.adjCurrLim'),
				name: 'adjCurrLim',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.lightLoadEffEnhance'),
				name: 'lightLoadEffEnhance',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.spreadSpectrum'),
				name: 'spreadSpectrum',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.forcedPWM'),
				name: 'forcedPWM',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.internalCompensation'),
				name: 'internalComp',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.powerGood'),
				name: 'powerGood',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.adjustableUvlo'),
				name: 'adjustableUvlo',
				forced: false
			},
			{
				label: 'PMBus/I\u00b2C',
				name: 'pmBus',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.ovp'),
				name: 'ovp',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.multiPhase'),
				name: 'multiPhase',
				forced: false
			},
			/* Boost */
			{
				label: i18n.t('components.filterBar.constants.icFeatures.trueLoadDisc'),
				name: 'trueLoadDisconnect',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.passThroughMode'),
				name: 'passThroughMode',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.bypassMode'),
				name: 'bypassMode',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.digitalVout'),
				name: 'digitalVout',
				forced: false
			},
			/* Flyback */
			{
				label: i18n.t('components.filterBar.constants.icFeatures.inputVoltageUVLOPin'),
				name: 'inputVoltageUVLOPin',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.inputVoltageOVLOPin'),
				name: 'inputVoltageOVLOPin',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.standbyMod'),
				name: 'standbyMod',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.scp'),
				name: 'scp',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.brownOut'),
				name: 'brownOut',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.hvStartup'),
				name: 'hvStartup',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.overPowerComp'),
				name: 'overPowerComp',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.integratedMSO'),
				name: 'integratedMainSwitchOnly',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.outputOVP'),
				name: 'ouputOVP',
				forced: false
			},
			/* LDO */
			{
				label: i18n.t('components.filterBar.constants.icFeatures.biasPin'),
				name: 'biasPin',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.dischargeOption'),
				name: 'dischargeOption',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.reverseBattery'),
				name: 'reverseBatteryProtection',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.icFeatures.loadDump'),
				name: 'loadDump',
				forced: false
			}
		]
	},
	{
		label: i18n.t('components.filterBar.checkboxFilters.controlScheme'),
		name: 'controlScheme',
		booleanFilters: false,
		filters: [
			{
				label: i18n.t('components.filterBar.constants.controlScheme.cm'),
				name: 'CM',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.controlScheme.vm'),
				name: 'VM',
				forced: false
			},
			{
				label: i18n.t('components.filterBar.constants.controlScheme.cot'),
				name: 'COT',
				forced: false
			}
		]
	}
];
